module.exports = __webpack_public_path__ + "img/2.3967f638.svg";